import { render, staticRenderFns } from "./ContactInfoCard.vue?vue&type=template&id=5c7d88da"
import script from "./ContactInfoCard.vue?vue&type=script&lang=js"
export * from "./ContactInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports